// Brand logo as inline SVG.
//
// Inline rather than an icon CDN: this page must render offline and the
// trademark is intentionally a small path set. Google's colours are the
// brand's own — a logo tile is recognisably the thing it says, which is the
// point of the design. Dynatrace and SAP use brand-supplied images in
// public/logos instead.

export function GoogleDriveLogo({ className = "h-8 w-8" }: { className?: string }) {
  return (
    <svg viewBox="0 0 87.3 78" className={className} aria-hidden="true">
      <path
        d="M6.6 66.85l3.85 6.65c.8 1.4 1.95 2.5 3.3 3.3L27.5 53H0c0 1.55.4 3.1 1.2 4.5z"
        fill="#0066da"
      />
      <path
        d="M43.65 25L29.9 1.2c-1.35.8-2.5 1.9-3.3 3.3l-25.4 44A9.06 9.06 0 000 53h27.5z"
        fill="#00ac47"
      />
      <path
        d="M73.55 76.8c1.35-.8 2.5-1.9 3.3-3.3l1.6-2.75L86.1 57.5c.8-1.4 1.2-2.95 1.2-4.5H59.798l5.852 11.5z"
        fill="#ea4335"
      />
      <path d="M43.65 25L57.4 1.2C56.05.4 54.5 0 52.9 0H34.4c-1.6 0-3.15.45-4.5 1.2z" fill="#00832d" />
      <path
        d="M59.8 53H27.5L13.75 76.8c1.35.8 2.9 1.2 4.5 1.2h50.8c1.6 0 3.15-.45 4.5-1.2z"
        fill="#2684fc"
      />
      <path d="M73.4 26.5l-12.7-22c-.8-1.4-1.95-2.5-3.3-3.3L43.65 25 59.8 53h27.45c0-1.55-.4-3.1-1.2-4.5z" fill="#ffba00" />
    </svg>
  )
}

/** Shopify's shopping bag, inline for the same reason as Drive's mark: the
 *  Connections page renders offline and the brand is a small path set. */
export function ShopifyLogo({ className = "h-8 w-8" }: { className?: string }) {
  return (
    <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
      <path
        fill="#95BF47"
        d="M44.5 13.2c-.2 0-4.2-.1-4.2-.1s-2.8-2.8-3.1-3.1c-.3-.3-.9-.2-1.1-.1l-1.1.3c-.7-1.9-1.9-3.6-3.9-3.6h-.2c-.6-.7-1.3-1-1.9-1-4.8 0-7.1 6-7.8 9.1l-3.4 1c-1 .3-1.1.4-1.2 1.3-.1.7-3.4 25.6-3.4 25.6l21.7 4.1 11.7-2.5s-2.9-31.1-2.9-31.5c0-.3-.2-.5-.4-.5zM32.6 10.7l-1.9.6c0-1.4-.2-3.3-.9-4.6 1.8.2 2.8 2.3 2.8 4zm-3.7-.8c-.8 2.4-1 5.7-1 5.7l-3.8 1.2c.7-2.8 2.1-5.3 4.8-6.9zM26.3 6.2c.6 0 1 .2 1.4.5-2.4 1.1-5 4-6.1 9.6l-3 .9c1-4.2 3.3-11 7.7-11z"
      />
      <path
        fill="#5E8E3E"
        d="M44.1 12.7c-.2 0-4.2-.1-4.2-.1s-2.8-2.8-3.1-3.1c-.1-.1-.3-.2-.4-.2v46.7l11.7-2.5s-2.9-31.1-2.9-31.5c0-.3-.2-.5-.4-.5z"
      />
      <path
        fill="#fff"
        d="M29.1 23.6l-1.5 4.4s-1.3-.7-2.9-.7c-2.4 0-2.5 1.5-2.5 1.8 0 2 5.2 2.8 5.2 7.6 0 3.7-2.4 6.1-5.5 6.1-3.8 0-5.7-2.4-5.7-2.4l1-3.4s1.9 1.7 3.6 1.7c1.1 0 1.6-.8 1.6-1.5 0-2.6-4.3-2.7-4.3-7.2 0-3.7 2.6-7.2 7.9-7.2 2 0 3.1.6 3.1.6z"
      />
    </svg>
  )
}
